import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { verifyEmailToken } from '../lib/sqlAuth';
import '../csscomponent/AuthAssist.css';
import useSingleTapNavigate from '../lib/useSingleTapNavigate';
import BrandLoader from './mobile/BrandLoader';

export default function VerifyEmail() {
  const { goTo, navLocked } = useSingleTapNavigate();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => (searchParams.get('token') || '').trim(), [searchParams]);
  const statusParam = useMemo(() => (searchParams.get('status') || '').trim(), [searchParams]);
  const messageParam = useMemo(() => (searchParams.get('message') || '').trim(), [searchParams]);
  const [status, setStatus] = useState(() => {
    if (messageParam) return messageParam;
    return 'Verifying your email...';
  });

  useEffect(() => {
    let mounted = true;

    const verify = async () => {
      if (messageParam) {
        if (mounted) setStatus(messageParam);
        return;
      }

      if (!token) {
        if (mounted) setStatus('Verification token is missing or invalid.');
        return;
      }

      try {
        const result = await verifyEmailToken({ token });
        if (mounted) setStatus(result?.message || 'Email verified successfully.');
      } catch (error) {
        if (mounted) setStatus(error?.message || 'Unable to verify email right now.');
      }
    };

    verify();
    return () => {
      mounted = false;
    };
  }, [token, messageParam, statusParam]);

  return (
    <div className="auth-assist-page">
      <div className="auth-assist-card">
        <div className="auth-assist-topbar">
          <button
            type="button"
            className="auth-assist-back"
            onClick={() => goTo('/login')}
            disabled={navLocked}
          >
            Back to Login
          </button>
          <button
            type="button"
            className="auth-page-skip auth-assist-skip"
            onClick={() => goTo('/home')}
            disabled={navLocked}
          >
            Skip
          </button>
        </div>
        <h1>Email Verification</h1>
        <p className="auth-assist-message">{status}</p>
        {status === 'Verifying your email...' ? <BrandLoader compact label="Verifying" /> : null}
        <button type="button" onClick={() => goTo('/login')} disabled={navLocked}>
          Continue to Login
        </button>
      </div>
    </div>
  );
}
